module.exports = __webpack_public_path__ + "static/media/timetable-16-01.6072709b.svg";